
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { MessageSquare, Lightbulb, Code, FileText, Zap, Mail } from "lucide-react";

interface QuickActionsProps {
  onSendMessage: (message: string) => void;
}

const quickPrompts = [
  {
    icon: MessageSquare,
    title: "Ask a Question",
    prompt: "I have a question about...",
    description: "Get help with anything"
  },
  {
    icon: Mail,
    title: "Professional Email",
    prompt: "Help me write a professional email for business communication",
    description: "Create formal emails"
  },
  {
    icon: Mail,
    title: "Follow-up Email",
    prompt: "Help me draft a follow-up email to check on previous correspondence",
    description: "Professional follow-ups"
  },
  {
    icon: Lightbulb,
    title: "Brainstorm Ideas",
    prompt: "Help me brainstorm ideas for...",
    description: "Generate creative solutions"
  },
  {
    icon: Code,
    title: "Code Review",
    prompt: "Can you review this code and suggest improvements?",
    description: "Get code feedback"
  },
  {
    icon: FileText,
    title: "Write Content",
    prompt: "Help me write...",
    description: "Create documents and text"
  }
];

export function QuickActions({ onSendMessage }: QuickActionsProps) {
  return (
    <div className="shrink-0 p-6 border-t border-border/50">
      <div className="max-w-4xl mx-auto">
        <h3 className="text-sm font-medium text-muted-foreground mb-4">Quick Actions</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {quickPrompts.slice(0, 6).map((prompt, index) => (
            <Card
              key={index}
              className="p-4 cursor-pointer hover:bg-muted/50 transition-colors border-border/50 bg-background/50"
              onClick={() => onSendMessage(prompt.prompt)}
            >
              <div className="flex items-start gap-3">
                <div className="h-8 w-8 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
                  <prompt.icon className="h-4 w-4 text-primary" />
                </div>
                <div className="min-w-0">
                  <h4 className="text-sm font-medium mb-1">{prompt.title}</h4>
                  <p className="text-xs text-muted-foreground">{prompt.description}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
